/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Utils\ThemeColor.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Thursday August 31st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday August 31st 2023 4:52:30 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { MyColors } from "Config/Theme/Theme.type";

export function getThemeColor(value?: string, theme?: MyColors): string {
    var color = "";
    switch (value) {
        case "CITYCAR":
            color = "var(--root-colors-second)";
            break;
        case "SUV":
            color = "var(--root-colors-third)";
            break;
        case "UTILITY":
            color = "var(--root-colors-fourth)";
            break;
        case "SEDAN":
            color = "var(--root-colors-fifth)";
            break;
        case "BREAK":
            color = "var(--root-colors-sixth)";
            break;
        case "-light":
            color = "#6ca3db";
            break;
        case "CITYCAR-light":
            color = "#d4e754";
            break;
        case "SUV-light":
            color = "#7cbde0";
            break;
        case "UTILITY-light":
            color = "#f8de48";
            break;
        case "SEDAN-light":
            color ="#c1c0fa";
            break;
        case "BREAK-light":
            color = "#df8bb3";
            break;
        case undefined:
        case "":
        default:
            color = "var(--root-colors-first)";
            break;
    }
    return color;
}

export function offerColor(status: string) {
    var color = "black";
    switch (status) {
        case "ACCEPTED":
            color = "green"
            break;
        case "RESERVED":
            color = "blue"
            break;
        case "CANCEL":
            color = "red"
            break;
        case "PENDING":
            color = "orange"
            break;

        default:
            break;
    }
    return color;
};
